import React, { useEffect, useState } from 'react';
import Fetch from '../../../functions/Fetch';
import config from '../../../../../../config/config';
import '../ReportStyle.css';
import moment from 'moment';
import * as XLSX from 'xlsx'
import ExportButtons from '../ExportButtons';
import { formatCurrency } from '../../../../../../helpers/pcontas';

const DirdRevenueReport = (props) => {
    const [items, setItems] = useState([]);

    const startDate = moment(props.filters.startDate).format('DD/MM/YYYY');
    const endDate = moment(props.filters.endDate).format('DD/MM/YYYY');

    useEffect(() => {
        const fetchData = async () => {
            console.log('Fetching Dird Revenue Report with filters:', props.filters);
            const response = await Fetch.post(config.endpoints.backend + 'portal/getreport', props.filters);
            setItems(response);
        }

        fetchData();
    }, [props.filters])

    function dataForSheet(){
        let sheets = {};
        if(items.reports.data.headersFirstTable.length > 0){
            const demonstrativesRevenueTable = document.getElementById('demonstrativesRevenueTable');
            const demonstrativesRevenueData = XLSX.utils.sheet_to_json((XLSX.utils.table_to_sheet(demonstrativesRevenueTable, {raw: true})), {raw: true, header: 1});
            sheets.demonstrativesRevenueData = demonstrativesRevenueData;
        }
        const sourceReceiptRevenueTable = document.getElementById('sourceReceiptRevenueReport');
        const sourceReceiptRevenueData = XLSX.utils.sheet_to_json((XLSX.utils.table_to_sheet(sourceReceiptRevenueTable, {raw: true})), {raw: true, header: 1});

        sheets.sourceReceiptRevenueData = sourceReceiptRevenueData;
        
        return sheets;
    }

    function dataForCsv() {
        const tableSourceReceiptReport = document.getElementById('sourceReceiptRevenueReport');
    
        const dataTableSourceReceiptReport = XLSX.utils.sheet_to_json(XLSX.utils.table_to_sheet(tableSourceReceiptReport, {raw: true}), { header: 1, raw: true});

        let combinedData = [];

        if(items.reports.data.headersFirstTable.length > 0){
            const tableDemonstrativesReport = document.getElementById('demonstrativesRevenueTable');
            const dataTableDemonstrativesReport = XLSX.utils.sheet_to_json(XLSX.utils.table_to_sheet(tableDemonstrativesReport, {raw: true}), { header: 1, raw: true});
            combinedData = combinedData.concat(dataTableDemonstrativesReport);
            combinedData.push([]);
        }

        combinedData = combinedData.concat(dataTableSourceReceiptReport);

        return combinedData
    }

    function dataForJson(){
        let dirdRevenue = {};
        let dirdRevenueDemonstratives = [];

        items.reports.data.sourcesReceipts.forEach(item => {
            dirdRevenue[item.description] = item.value;
        });

        if(!!items.reports.data.transfers){
            let currentRevenueDemonstrative = {};
            items.reports.data.transfers.forEach(item => {
                for (const key of items.reports.data.headersFirstTable) {
                    currentRevenueDemonstrative[key] = item[key];
                }
                dirdRevenueDemonstratives.push(currentRevenueDemonstrative);
                currentRevenueDemonstrative = {};
            })
        }

        return {
            dirdRevenueDemonstratives,
            dirdRevenue
        };
    }

    return (
        <div>
        {items.reports && (
                <div className='containerDird'>   
                    <div className='row info-filters'>
                        <div className='col-12'>
                            <p>Projeto: <b>{items.reports.pdcProject.project_name}</b></p>
                        </div>
                        <div className='col-12'>
                            <p>Origem dos Recursos: <b>{items.reports.originResourceName}</b></p>
                        </div>
                        <div className='col-12'>
                            <p>Período Selecionado: <b>{startDate} até {endDate}</b></p>
                        </div>
                    </div>
                    <div className='row mb-2'>
                        <ExportButtons 
                            jsonData={dataForJson} 
                            csvData={dataForCsv} 
                            sheetData={dataForSheet} 
                            pdfAttributes={{
                                    ids: ['demonstrativesRevenueTable', 'sourceReceiptRevenueReport']
                                }
                            }
                            txtAttributes={{
                                demonstrativesRevenueTable: {
                                    colSizes: [80]
                                },
                                sourceReceiptRevenueReport: {
                                    colSizes: [80]
                                }
                            }}
                        />
                    </div>
                    <div className='row'>
                        {items.reports.data.headersFirstTable.length > 0 && 
                            <table className="table tables-report" id="demonstrativesRevenueTable" margin="2" cellspacing="0" cellpadding="5">
                                <thead className='text-center '>
                                    <tr>
                                        <th colSpan={items.reports.data.headersFirstTable.length} className=''>DEMONSTRATIVO DOS RECURSOS DISPONÍVEIS DO EXERCÍCIO</th>
                                    </tr>
                                    <tr>
                                        {items.reports.data.headersFirstTable.map(header => (<th style={{maxWidth: '200px'}} className=''>{header}</th>))}
                                    </tr>
                                </thead>
                                <tbody className=''>
                                    {items.reports.data.transfers.map((row, rowIndex) => (
                                        <tr key={rowIndex} style={rowIndex === 4 ? {fontWeight: 'bold'} : {}}>
                                        {items.reports.data.headersFirstTable.map((item, keyIndex) => {
                                        let currentValue = items.reports.data.transfers[rowIndex][item];
                                        let className = keyIndex === 0 ? 'text-left' : 'text-right';
                                        let styleTd = '';
                                        return <td className={className} style={{...styleTd}}>{currentValue}</td>
                                        })}
                                        </tr>
                                    ))}
                                </tbody>
                        </table>}
                    </div>
                    <div className='row'>
                        <table className="table tables-report" id='sourceReceiptRevenueReport' margin="2" cellspacing="0" cellpadding="5">
                            <tbody className=''>
                                {items.reports.data.sourcesReceipts.map((row, rowIndex) => (
                                    <tr key={rowIndex} style={rowIndex === 4 ? {fontWeight: 'bold'} : {}}>
                                    {Object.keys(row).map((item, keyIndex) => {
                                       let currentValue = keyIndex === 0 ? items.reports.data.sourcesReceipts[rowIndex][item] : formatCurrency(items.reports.data.sourcesReceipts[rowIndex][item]);
                                       let className = keyIndex === 0 ? 'text-left' : 'text-right';
                                       let styleTd = '';
                                       return <td className={className} style={{...styleTd}}>{currentValue}</td>
                                    })}
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            )}
        </div>
    );
};
    
export default DirdRevenueReport;
    